// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + "main" + "." + "41984c1bd6b9dfa7d969" + ".css";
};